"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
exports.convertToTimestamp = function (timestamp) {
    return moment_timezone_1.default(timestamp)
        .tz('America/Toronto')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.convertTimestampToDate = function (timestamp) {
    return moment_timezone_1.default(timestamp)
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getCurrentDate = function () {
    return moment_timezone_1.default()
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getEarlierDate = function (date) {
    return moment_timezone_1.default(date)
        .subtract(2, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getFutureDate = function (date) {
    return moment_timezone_1.default(date)
        .add(1, 'days')
        .tz('America/Toronto')
        .format('YYYY-MM-DD');
};
exports.getCurrentQuarter = function (date) {
    var quarter = moment_timezone_1.default(date)
        .tz('America/Toronto')
        .quarter()
        .toString();
    return "Q" + quarter;
};
exports.getCurrentTimestampDate10Decimal6 = function () {
    return moment_timezone_1.default()
        .tz('America/Toronto')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getCurrentTimestampMinusMinutes = function (minutes) {
    return moment_timezone_1.default()
        .tz('America/Toronto')
        .subtract(minutes, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getCurrentTimestampAddMinutes = function (minutes) {
    return moment_timezone_1.default()
        .tz('America/Toronto')
        .add(minutes, 'minutes')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.addSecondsToTimestamp = function (timestamp, seconds) {
    return moment_timezone_1.default(timestamp)
        .add(seconds, 'seconds')
        .format('YYYY-MM-DD HH:mm:ss.SSSSSS');
};
exports.getCurrentYear = function (date) {
    return moment_timezone_1.default(date)
        .tz('America/Toronto')
        .format('YYYY');
};
exports.getDurationInMinutes = function (createTime, updateTime) {
    var createMoment = moment_timezone_1.default(createTime).tz('America/Toronto');
    var updateMoment = moment_timezone_1.default(updateTime).tz('America/Toronto');
    return Math.abs(moment_timezone_1.default.duration(createMoment.diff(updateMoment)).asMinutes());
};
exports.checkIfDateIsAfterComparedDate = function (beforeDate, comparedDate) {
    if (beforeDate == null) {
        return false;
    }
    if (comparedDate == null) {
        return true;
    }
    return moment_timezone_1.default(beforeDate).isAfter(comparedDate);
};
exports.getMostRecentDate = function (dates) {
    return dates.reduce(function (firstDate, secondDate) {
        return exports.checkIfDateIsAfterComparedDate(firstDate, secondDate) ? firstDate : secondDate;
    });
};
exports.datesDifference = function (date1, date2) {
    return moment_timezone_1.default(date2).diff(moment_timezone_1.default(date1));
};
